<template>
  <div>
    <ProjectBaseView>
      <div v-if="this.$store.state.project" class="project-home-view-main-div">
        <!-- Wallpaper -->
        <div class="wallpaper-div" :style="{
          background: page.background.startsWith('#')
            ? page.background
            : `url(${page.background})`
        }">
        </div>

      <!-- Secciones -->
      <div class="section">
        <div v-html="renderMarkdown(page.content)" class="markdown-content"></div>
      </div>
    </div>
    <div v-else>Cargando proyecto...</div>
  </ProjectBaseView>
  </div>
</template>

<script>
import { marked } from 'marked'; // Importa la librería para procesar Markdown
import ProjectBaseView from "./ProjectBaseView.vue";
export default {
  name: "ProjectHomeView",
  components: {
    ProjectBaseView,
  },
  computed: {
    page() {
      return this.$store.state.project.pages[this.$route.params.pageIndex];
    }
  },
  watch: {
    '$store.state.project.name': 'setPageName'
  },
  methods: {
    renderMarkdown(content) {
      return marked(content); // Convierte el texto de Markdown a HTML
    },
    setPageName() {
      if (this.$store.state.project && this.$store.state.project.name) {
        document.title = `${this.$store.state.project.name}`;
      }
    }
  },
  async created() {
    this.setPageName();
  },
};
</script>

<style scoped>
.project-home-view-main-div {
  overflow-y: auto;
  height: 100vh;
  width: 100%;

  /* Debugg */
  /* background-color: pink;
  padding: 5px;
  border: 2px dashed white; */
}

.wallpaper-div {
  height: 200px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 7px;
}

.secciones-container {
  display: flex;
  justify-content: center;

  /* Debugg */
}

.section {
  width: 100%;
  text-wrap: wrap;
  padding: 1%;
  padding-left: 15%;
  padding-right: 15%;
  /* background-color: blue; */

  /* Debugg */
  /* background-color: red; */
}

.markdown-content {
  word-wrap: break-word; /* Asegura que el contenido se ajuste al contenedor */
  overflow-wrap: break-word; /* Asegura que el contenido se ajuste al contenedor */
  max-width: 100%; /* Asegura que el contenido no se salga del contenedor */
}
</style>
